// The one definition of what HTML a QMS policy body may contain.
//
// Lives in the frontend tree because both sides need it and the Worker already
// imports shared rules from here (rbac.js is the precedent). The server's
// sanitiser (src/lib/sanitiseHtml.js) applies it on write; the viewer applies it
// again through DOMPurify on read. If the two ever disagreed, content could be
// stored that the viewer refuses to show, or shown that the server never
// vetted, so there is one list.

export const QMS_ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'h4',
  'p', 'br', 'hr', 'blockquote',
  'ul', 'ol', 'li',
  'strong', 'em', 'u', 's',
  'a', 'img',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
];

// Attribute allowlist per element. Anything else (style, class, id, data-*,
// every on* handler, target, rel, width) is dropped.
export const QMS_ALLOWED_ATTRIBUTES = {
  a: ['href'],
  img: ['src'],
  td: ['colspan', 'rowspan'],
  th: ['colspan', 'rowspan'],
};

// Where a link or an image may point. Links: https, mailto and in-page anchors.
// Images: only the app's own asset route, so a body never pulls from a third
// party and never carries an inline data: URI.
export const QMS_ALLOWED_URI = /^(?:https:\/\/|mailto:|#|\/api\/qms\/)/i;

// Allowed attributes whose value is not a URI. DOMPurify tests the value of
// every allowed attribute against ALLOWED_URI_REGEXP unless it is listed as
// URI-safe, so without this rowspan="4" fails the link pattern and is dropped,
// and every merged cell in an imported Word table comes apart.
const NON_URI_ATTRIBUTES = ['colspan', 'rowspan'];

/** DOMPurify configuration equivalent to the server allowlist. */
export const QMS_DOMPURIFY_CONFIG = {
  ALLOWED_TAGS: QMS_ALLOWED_TAGS,
  ALLOWED_ATTR: [...new Set(Object.values(QMS_ALLOWED_ATTRIBUTES).flat())],
  ADD_URI_SAFE_ATTR: NON_URI_ATTRIBUTES,
  ALLOWED_URI_REGEXP: QMS_ALLOWED_URI,
  ALLOW_DATA_ATTR: false,
  KEEP_CONTENT: true,
};
